import type { EmbeddedType } from '@app-types/embedded'
import type { WithTestId } from '@lib/utils/testid'
import classNames from 'classnames'
import type { FunctionComponent } from 'react'

import styles from './embedded.module.scss'

/**
 * Displays an iframe.
 */
export const Embedded: FunctionComponent<EmbeddedProps> = ({
    title,
    src,
    width,
    aspectRatio,
    allow,
    'data-testid': testId,
}) => {
    return (
        <figure
            className={classNames(
                styles.wrapper,
                aspectRatio && styles[`ratio-${aspectRatio.replace(':', '_')}`],
            )}
            role='video'
            data-testid={testId}
            style={{ width }}
        >
            <iframe
                className={styles.iframe}
                title={title}
                allow={allow}
                data-testid={testId}
                allowFullScreen
                frameBorder={0}
                src={src.replace('youtube.com', 'youtube-nocookie.com')}
            />
        </figure>
    )
}

export type EmbeddedProps = WithTestId<EmbeddedType>
